export default __webpack_public_path__ + "static/PlayGame-8326e3b2298a15aab2addd98678a348f.svg";